import { Button } from '@/components/shared/buttons/button';
import { Divider } from '@/components/shared/element/divider';
import { HeadingLevel1 } from '@/components/shared/headline/heading-level-1';
import { Container } from '@/components/shared/layout/container';
import { IIcon } from '@/types/shared';
import { ITest, ITracking } from '@/types/tracking';

interface DealerHeaderProps {
  title: string;
  description: string;
  searchCurrentPositionButton: {
    label?: string;
    icon?: IIcon;
    tracking?: ITracking;
    test?: ITest;
    isLoading: boolean;
    handleClick: () => void;
  };
}

export const DealerHeader: React.FunctionComponent<DealerHeaderProps> = (
  props: DealerHeaderProps
) => {
  return (
    <header>
      <HeadingLevel1 title={props.title} description={props.description}>
        <Button
          label={props.searchCurrentPositionButton.label}
          icon={props.searchCurrentPositionButton.icon}
          tracking={props.searchCurrentPositionButton.tracking}
          test={props.searchCurrentPositionButton.test}
          isLoading={props.searchCurrentPositionButton.isLoading}
          onClick={props.searchCurrentPositionButton.handleClick}
        />
      </HeadingLevel1>
      <Container
        css={{
          '@maxlg': {
            display: 'none',
          },
        }}
      >
        <Divider />
      </Container>
    </header>
  );
};

DealerHeader.displayName = 'SectionDealerHeader';
